































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { PTOPolicy, PTOPolicyFilter } from "@/dto/payroll/policies/PTOPolicyDTO";
import Application from "@/state/Application";
import PolicyService from "@/services/payroll/PolicyService";
import { processError } from "@/utils/ComponentUtils";
import { prettyEnum } from "@/utils/StringUtils";
import PTOPolicyCard from "@/components/payroll/policies/pto/PTOPolicyCard.vue";
import RouteNames from "@/router/RouteNames";

@Component({
	components: { PTOPolicyCard }
})
export default class CompanyPTOPolicyList extends Vue {
	@Prop({ required: true })
	private companyId!: number;

	private ptoList: PTOPolicy[] = [];
	private loading = true;
	private RouteNames = RouteNames;

	private get filter(): PTOPolicyFilter {
		return new PTOPolicyFilter({
			companyId: this.$wss.getCurrent.id,
			isActive: null,
			pageSize: 100,
			pageNumber: 0
		});
	}

	public created(): void {
		this.loadPolicies();
	}

	@Watch("companyId")
	private onCompanyIdChange(): void {
		this.loadPolicies();
	}

	private loadPolicies(): void {
		Application.startLoading();
		this.loading = true;
		PolicyService.getPageOfPTOPolicies(this.filter).then(
			res => {
				this.ptoList = res.data.data || [];
				Application.stopLoading();
				this.loading = false;
			},
			err => {
				processError(err, this);
				this.loading = false;
				Application.stopLoading();
			}
		);
	}

	private toSignPage(publicId: string): void {
		this.$router.push({ name: RouteNames.SIGN_PUBLIC, params: { publicId } });
	}

	private prettyEnum = prettyEnum;
}
